import React from "react";
import { styled } from "@mui/material";
import { Box } from "@mui/material";
import ErrorBackgroundImage from "./error-background.svg?react";

const BackgroundImage = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  overflow: "hidden",
  width: "100%",
  height: "100%",
  zIndex: 0,
  pointerEvents: "none",

  "& svg": {
    color: theme.palette.error.main,
    position: "absolute",
    opacity: 0.5,
    left: "0",
    top: "0",
  },
}));

export const ErrorBackground = () => {
  return (
    <BackgroundImage>
      <ErrorBackgroundImage />
    </BackgroundImage>
  );
};
